import styles from './ContactForm.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'

const ContactForm: React.FC = () => {
  useHubSpotGenerate('na1', '9395227', '7e4d0b60-42b7-4449-8592-f5f2a9e98307', '#hbspt')

  return (
    <>
      <section className={styles.contact} id="Contact">
        <div className={styles.top}>
          <div className={styles.textWrapper}>
            <p className={`${styles.redText} ${styles.introText}`}>Contact</p>
            <p className={styles.p}>お問い合わせ</p>
          </div>
        </div>
        <div className={styles.hubSpot} id="hbspt"></div>
      </section>
    </>
  )
}

export default ContactForm
